(function () {
  'use strict';

  // Global install: orphans can appear after /cart/change.js outside .cart--section
  // (qty→0, direct API, or a future drawer). Reconcile on every page + checkout guard.
  if (window.__gsgCartBundleIntegrity) return;
  window.__gsgCartBundleIntegrity = true;

  var section = document.querySelector('.cart--section');
  var busy = false;
  // Promise for the in-flight reconcile/remove so checkout can wait instead of erroring.
  var busyWait = Promise.resolve();
  // Generation token: a late update that finishes after timeout/abandon must not reload.
  var busyWaitId = 0;
  // Single-flight: ignore extra checkout / express attempts while one is in progress.
  var checkoutStarted = false;
  var BUSY_WAIT_MS = 10000;

  function nextBusyWaitId() {
    busyWaitId += 1;
    return busyWaitId;
  }

  function isCurrentBusyWait(id) {
    return id === busyWaitId;
  }

  function showError() {
    var host = section || document.body;
    if (!host) return;
    var message = (section && section.querySelector('[data-gsg-bundle-error]')) || document.querySelector('[data-gsg-bundle-error]');
    if (!message) {
      message = document.createElement('p');
      message.setAttribute('role', 'alert');
      message.setAttribute('data-gsg-bundle-error', '');
      message.style.cssText = 'padding:12px 16px;margin:12px 0;background:#fde8e8;color:#7a1212;border-radius:6px;';
      var form = section && section.querySelector('form');
      if (form) form.insertBefore(message, form.firstChild);
      else host.insertBefore(message, host.firstChild);
    }
    if (message) message.textContent = 'Could not update the enclosure and its add-ons together. Please refresh the cart before checkout.';
  }

  // Race a promise against a fixed timeout. Rejects with code GSG_BUSY_TIMEOUT on expiry.
  function withBusyTimeout(promise) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        var err = new Error('Enclosure bundle wait timed out');
        err.code = 'GSG_BUSY_TIMEOUT';
        reject(err);
      }, BUSY_WAIT_MS);
      Promise.resolve(promise).then(function (value) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(value);
      }, function (error) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        reject(error);
      });
    });
  }

  function releaseCheckoutLock() {
    checkoutStarted = false;
  }

  function failCheckoutWait(error) {
    console.error('Enclosure bundle checkout wait failed', error);
    busy = false;
    // Invalidate in-flight reconcile/remove so a late resolve cannot reload the page.
    nextBusyWaitId();
    releaseCheckoutLock();
    showError();
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('Could not read cart');
      return response.json();
    });
  }

  function updateCart(updates) {
    function runUpdate() {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not update cart');
        return response.json();
      });
    }
    window.__gsgCartMutations = (window.__gsgCartMutations || Promise.resolve()).catch(function () {}).then(runUpdate);
    return window.__gsgCartMutations;
  }

  function bundleId(item) {
    return item.properties && item.properties._gsg_bundle_id;
  }

  function bundleRole(item) {
    return item.properties && item.properties._gsg_bundle_role;
  }

  function orphanUpdates(cart) {
    var updates = Object.create(null);
    if (!cart || !Array.isArray(cart.items)) return updates;

    var baseQuantities = Object.create(null);
    cart.items.forEach(function (item) {
      var id = bundleId(item);
      if (id && bundleRole(item) === 'base') {
        baseQuantities[id] = (baseQuantities[id] || 0) + item.quantity;
      }
    });

    cart.items.forEach(function (item) {
      var id = bundleId(item);
      if (!id || bundleRole(item) !== 'addon') return;
      var desired = baseQuantities[id] || 0;
      if (item.quantity !== desired) updates[item.key] = desired;
    });
    return updates;
  }

  function reconcile(cart, options) {
    options = options || {};
    if (busy || !cart || !Array.isArray(cart.items)) return Promise.resolve(cart);

    var updates = orphanUpdates(cart);
    if (!Object.keys(updates).length) return Promise.resolve(cart);

    busy = true;
    var waitId = nextBusyWaitId();
    busyWait = updateCart(updates).then(function (nextCart) {
      if (!isCurrentBusyWait(waitId)) return nextCart;
      if (options.reload !== false) {
        window.location.reload();
        return nextCart;
      }
      busy = false;
      return nextCart || getCart();
    }).catch(function (error) {
      console.error('Enclosure bundle cart reconciliation failed', error);
      if (isCurrentBusyWait(waitId)) {
        busy = false;
        showError();
      }
      throw error;
    });
    return busyWait;
  }

  // Capture-phase base remove: only when cart section is present (Empire remove link).
  document.addEventListener('click', function (event) {
    if (!section) return;
    var link = event.target.closest && event.target.closest('[data-cartitem-remove]');
    var row = link && link.closest('[data-cartitem]');
    if (!row || !section.contains(row) || row.getAttribute('data-gsg-bundle-role') !== 'base') return;

    var id = row.getAttribute('data-gsg-bundle-id');
    if (!id) return;
    var addonRows = Array.prototype.slice.call(section.querySelectorAll('[data-gsg-bundle-role="addon"]'));
    if (!addonRows.some(function (addon) { return addon.getAttribute('data-gsg-bundle-id') === id; })) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    var waitId = nextBusyWaitId();

    busyWait = getCart().then(function (cart) {
      var updates = Object.create(null);
      cart.items.forEach(function (item) {
        if (bundleId(item) === id) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) throw new Error('Enclosure bundle not found in cart');
      return updateCart(updates);
    }).then(function () {
      if (!isCurrentBusyWait(waitId)) return;
      window.location.reload();
    }).catch(function (error) {
      console.error('Enclosure bundle removal failed', error);
      if (isCurrentBusyWait(waitId)) {
        busy = false;
        showError();
      }
    });
  }, true);

  window.addEventListener('cartcount:update', function (event) {
    reconcile(event.detail);
  });

  // Checkout guard: form POST to /cart with name=checkout (and any cart form submit).
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '');
    if (action.indexOf('/cart') === -1) return;

    // Only intercept when the submitter is checkout (or no submitter info → treat as checkout if name=checkout buttons exist).
    var submitter = event.submitter;
    var isCheckout = !submitter || (submitter.getAttribute('name') === 'checkout') || submitter.classList.contains('shopify-payment-button__button');
    if (!isCheckout) return;
    if (form.getAttribute('data-gsg-orphan-guard-ok') === '1') {
      form.removeAttribute('data-gsg-orphan-guard-ok');
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    // Single-flight: drop duplicate submits while the first checkout path is running.
    if (checkoutStarted) return;
    checkoutStarted = true;

    function proceedCheckout() {
      busy = true;
      var waitId = nextBusyWaitId();
      // Bound the cart read/update themselves so a hung /cart.js cannot hang checkout forever.
      busyWait = withBusyTimeout(
        getCart().then(function (cart) {
          var updates = orphanUpdates(cart);
          if (!Object.keys(updates).length) return cart;
          return updateCart(updates);
        })
      ).then(function () {
        if (!isCurrentBusyWait(waitId)) return;
        busy = false;
        form.setAttribute('data-gsg-orphan-guard-ok', '1');
        // Prefer requestSubmit so the checkout submitter is preserved when supported.
        if (typeof form.requestSubmit === 'function') {
          if (submitter) form.requestSubmit(submitter);
          else form.requestSubmit();
        } else {
          form.submit();
        }
        // Leave checkoutStarted true — page is navigating to checkout.
      }).catch(function (error) {
        console.error('Enclosure bundle checkout guard failed', error);
        if (isCurrentBusyWait(waitId)) {
          busy = false;
          releaseCheckoutLock();
          showError();
        }
      });
      return busyWait;
    }

    // Wait (with 10s timeout) for any running reconcile/remove, then continue checkout.
    // On timeout: clear busy, show error, release lock, do not proceed.
    withBusyTimeout(Promise.resolve(busyWait).catch(function () {}))
      .then(function () {
        return proceedCheckout();
      })
      .catch(function (error) {
        failCheckoutWait(error);
      });
  }, true);

  // Best-effort: Shop Pay / additional checkout buttons skip the cart form submit.
  // Residual risk: clicks inside wallet iframes never reach this handler, so those
  // paths still cannot be awaited or single-flight locked. When we DO see a host
  // click while busy, wait (same 10s timeout) instead of erroring immediately.
  // After a successful wait the original click is already consumed (wallets need a
  // fresh user gesture), so we release the lock and let the customer click again.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.additional-checkout-buttons, .shopify-payment-button');
    if (!btn) return;

    if (checkoutStarted) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (busy) {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkoutStarted = true;
      withBusyTimeout(Promise.resolve(busyWait).catch(function () {}))
        .then(function () {
          // Reconcile finished; cannot safely re-open the wallet without a new gesture.
          releaseCheckoutLock();
        })
        .catch(function (error) {
          failCheckoutWait(error);
        });
      return;
    }

    // Speculative pre-clean; cannot reliably block wallet iframes.
    getCart().then(function (cart) {
      return reconcile(cart, { reload: false });
    }).catch(function () {});
  }, true);

  // Every page load: clean orphans even when not on the cart template.
  getCart().then(function (cart) {
    return reconcile(cart);
  }).catch(function (error) {
    console.error('Enclosure bundle check failed', error);
  });
})();
